import type { Module } from 'vuex'
import type { GetterTree } from 'vuex'
import type { ActionTree } from 'vuex'
import type { MutationTree } from 'vuex'
import type { RootState } from '../../../root/store/state';
import type { ILoaderState } from './loader-state'

const state: ILoaderState = {
    isLoader: false,
    isTimelineLoader: false,
    isTicketDescriptionLoader: false,
    isCommentEditLoader: false
}

const getters: GetterTree<ILoaderState, RootState> = {
    getLoading(state): boolean {
        return state.isLoader;
    },
    getTimeLineLoading(state): boolean {
        return state.isTimelineLoader;
    },
    getticketDescriptionLoading(state): boolean {
        return state.isTicketDescriptionLoader;
    },
    getCommentEditLoading(state): boolean {
        return state.isCommentEditLoader;
    },

}

const mutations: MutationTree<ILoaderState> = {
    SET_LOADING(state, value: boolean) {
        state.isLoader = value;
    },

    SET_TIMELINELOADING(state, value: boolean) {
        state.isTimelineLoader = value;
    },
    SET_TICKETDESCRIPTIONLOADING(state, value: boolean) {
        state.isTicketDescriptionLoader = value;
    },
    SET_COMMENTEDITLOADING(state, value: boolean) {
        state.isCommentEditLoader = value;
    }
}

const actions: ActionTree<ILoaderState, RootState> = {

    ShowLoader({ commit }, payload): any {
        return new Promise<void>((resolve) => {
            commit('SET_LOADING', payload)
            resolve();
        })
    },

    ShowTimelineLoader({ commit }, payload): any {
        commit('SET_TIMELINELOADING', payload)
    },
    ShowTicketDescriptionLoader({ commit }, payload): any {
        commit('SET_TICKETDESCRIPTIONLOADING', payload)
    },
    ShowCommentEditLoader({ commit }, payload): any {
        commit('SET_COMMENTEDITLOADING', payload)
    }
    

}

const namespaced: boolean = true
export const loaderModule: Module<ILoaderState, RootState> = {
    namespaced,
    state,
    getters,
    actions,
    mutations
}